export default "__VITE_ASSET__DDk2737z__"